// Einstiegspunkt fürs Bundling — bindet die App an <div id="root"> im HTML.
// microsoccer-rahmen.jsx bleibt reine Komponente (default export), diese
// Datei ist die einzige Stelle, die tatsächlich in den DOM rendert.
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./microsoccer-rahmen.jsx";

const container = document.getElementById("root");
createRoot(container).render(<App />);

// Stufe 3 (PWA-Grundlagen): Service Worker registrieren, damit die App
// installierbar ist und die App-Shell offline verfügbar bleibt. API-Aufrufe
// laufen laut sw.js immer übers echte Netz, nie aus dem Cache.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("./sw.js").catch((err) => {
      console.warn("Service Worker Registrierung fehlgeschlagen:", err);
    });
  });
}
